import config from '../../config/config';

export class My404Page {
	imageUrl: string;

	constructor() {
		this.imageUrl = `${config.portalUrl}/images/404.jpg`;
	}

	attached() {
		console.log('attached 404');
	}
}
